import { Component, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-all-in-one",
  templateUrl: "./all-in-one.component.html",
  styleUrls: ["./all-in-one.component.scss"],
})
export class AllInOneComponent implements OnInit {
  selectedImage: string | null = null;

  constructor(private meta: Meta, private seoService: SeoServiceService) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.meta.addTag({
      name: "Description",
      content: "High-Performance All-in-One PCs for Labs & Offices - Intel i3/i5/i7/i9 (13th Gen), SSD, 23.8”/27.0” displays.",
    });
  }

  openImagePopup(imageSrc: string): void {
    this.selectedImage = imageSrc;
  }

  closeImagePopup(): void {
    this.selectedImage = null;
  }

  pcConfigurations = [
    { icon: 'memory', title: 'Intel i3 / i5 / i7 / i9 (13th Gen)', description: 'Powerful processing options' },
    { icon: 'storage', title: '8 GB / 16 GB / 32 GB RAM', description: 'Multitasking made easy' },
    { icon: 'sd_storage', title: '256 GB / 512 GB / 1 TB and more SSD', description: 'Fast boot and load times' },
    { icon: 'desktop_windows', title: '23.8” / 27.0” displays', description: 'Clear and vibrant visuals' },
    { icon: 'settings', title: 'Operating System', description: 'Flexible Option for choosing Operating System' },
    { icon: 'memory', title: 'Processor Intel', description: '' },
  ];

  specSections = [
    {
      label: "ALL-IN-ONE PC SPECIFICATIONS",
      headerLabel: "Category",
      columns: ['Specification', '', ''],
      rows: [
        { label: "Display", values: ["Screen Size", "23.8\"", "27.0\""], rowspan: 6 },
        { label: "", values: ["Resolution", "Full HD 1920 × 1080"] },
        { label: "", values: ["Aspect Ratio", "16:9"] },
        { label: "", values: ["Refresh Rate", "60 Hz"] },
        { label: "", values: ["Viewing Angle", "H 178° / V 178°"] },
        { label: "", values: ["Brightness", "250 cd/m²"] },
        { label: "Motherboard & Performance", values: ["Motherboard", "Thin-mini ITX (170 × 170 mm)",], rowspan: 3 },
        { label: "", values: ["Graphics", "Integrated Graphics"] },
        { label: "", values: ["Cooling", "Copper pipe heat sink with fan"] },
        { label: "Memory & Storage", values: ["RAM", " 8 GB (Expandable options supported)",], rowspan: 3 },
        { label: "", values: ["SSD Options", "256GB / 512GB"] },
        { label: "", values: ["HDD", "Not Applicable"] },
        { label: "Wireless Connectivity", values: ["Wi-Fi", "Wi-Fi 6"], rowspan: 3 },
        { label: "", values: ["Bluetooth", "Version 5.0"] },
        { label: "", values: ["Wake-on-LAN (WOL)", "Supported"] },
        { label: "Camera & Audio", values: ["Camera", "Optional hidden camera (2 MP) with microphone"], rowspan: 3 },
        { label: "", values: ["Speakers", "4Ω / 3W × 2"] },
        { label: "", values: ["Audio Port", "Mic-In ×1, Line-Out ×1"] },
        { label: "Ports & Interfaces", values: ["Bottom Ports", "DC-IN ×1, HDMI OUT ×1, USB 3.0 ×2, USB 2.0 ×2, LAN (RJ45) ×1"], rowspan: 2 },
        { label: "", values: ["Side Ports", "USB Type-C ×1, SD Card Slot ×1, Audio Jack ×1"] },
        { label: "Power", values: ["Power Adapter", "19V / 6.32A", "12V / 5A"] },
        { label: "Design & Build", values: ["Color Options", "Black / White / Grey",], rowspan: 7 },
        { label: "", values: ["Base", "Regular / Adjustable"] },
        { label: "", values: ["Adjustment Angle", "Front 5° / Back 15°"] },
        { label: "", values: ["Dimensions", "540 × 325 × 54 mm"] },
        { label: "", values: ["Net Weight", "4.91 kg"] },
        { label: "", values: ["Gross Weight", "7.38 kg"] },
        { label: "", values: ["Kensington Lock", "Supported"] },
        { label: "Mounting", values: ["VESA Mount", "100 × 100 mm"] },
        { label: "Others", values: ["Accessories (Included)", "Wired/Wireless Keyboard, Wired/Wireless Mouse, Power Cord"] },
      ],
    }
  ];
}
